import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { Card, CardContent, Box } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 0,
  width: '100%',
  height: '100%',
  boxShadow: theme.boxShadow
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  height: '40.2rem',
  [theme.breakpoints.down('sm')]: {
    height: 'auto'
  }
}));

const BottomRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '2rem'
}));

// Placeholder card shown while the featured subscriptions load, mirroring
// SubscriptionItemLarge (cover, avatar, title, blurb, action row) so the section keeps
// its shape instead of popping in.
const SubscriptionItemLargeSkeleton = () => {
  return (
    <StyledCard>
      <Skeleton variant='rectangular' width='100%' height='28.6rem' />
      <StyledCardContent>
        <Skeleton variant='circular' width={78} height={78} sx={{ marginBottom: '2rem' }} />
        <Skeleton variant='text' width='70%' height='3.2rem' sx={{ marginBottom: '2rem' }} />
        <Box sx={{ flexGrow: 1 }}>
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' width='80%' />
        </Box>
        <BottomRow>
          <Skeleton variant='rectangular' width={120} height={44} sx={{ borderRadius: '0.7rem' }} />
          <Skeleton variant='text' width={60} height='3.2rem' />
        </BottomRow>
      </StyledCardContent>
    </StyledCard>
  );
};

export default SubscriptionItemLargeSkeleton;
